import React, { useEffect, useState } from 'react'
import Header from '../adminComponents/header/Header'
import { Box, Button, Card, CardContent, Grid, IconButton, Menu, MenuItem, Typography } from '@mui/material'
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { getOurStoryPurpose, deleteOurStoryPurpose } from '../services/OurStoryPurpose';
import { useNavigate } from 'react-router-dom';
import { useMediaQueries } from '../usecontext/UseProvider';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import DeleteModal from '../adminComponents/deleteModal/DeleteModal';

const StoryPerpose = () => {
    const [storyData, setStoryData] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const { setLoading } = useMediaQueries();
    const navigate = useNavigate();

    const getOurStoryPurposeData = async () => {
        try {
            setLoading(true);
            const response = await getOurStoryPurpose();
            setStoryData(response?.ourStoryPurpose);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getOurStoryPurposeData();
    }, []);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOnDelete = (item) => {
        setSelectedItem(item);
        setDeleteOpen(true);
        setAnchorEl(null);
    };

    const handleDeleteConfirm = async () => {
        try {
            setLoading(true);
            await deleteOurStoryPurpose(selectedItem._id);
            await getOurStoryPurposeData(); // Refresh the list
            setDeleteOpen(false);
        } catch (error) {
            console.error('Error deleting item:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    return (
        <>
            <Header title="Story And Perpose" />
            <Box sx={{ pt: 3 }}>
                <Box textAlign={'end'} mb={2}>
                    <Button
                        onClick={() => navigate('/admin/story-perpose/add')}
                        variant="contained"
                        startIcon={<AddIcon sx={{ border: '2px dashed #FFFFFF', borderRadius: '50px', p: 0.5 }} />}
                        sx={{ bgcolor: "#01A0E2", color: "white", borderRadius: '30px' }}>
                        Add new story and purpose
                    </Button>
                </Box>
                <Grid container spacing={{ sm: 3, xs: 1 }} sx={{ px: { lg: 3, xs: 0 } }}>
                    {storyData?.map((item, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index} >
                            <Card
                                sx={{
                                    boxShadow: '0px 0px 59px 0px #0000000D',
                                    position: 'relative',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    p: { sm: 2, xs: 0 },
                                    zIndex: 1,
                                    height: '100%',
                                }}
                            >
                                {/* Action Menu */}
                                <Box sx={{ position: "absolute", top: 10, right: 10 }}>
                                    <IconButton
                                        sx={{ bgcolor: "rgba(255, 255, 255, 0.8)" }}
                                        size="small"
                                        onClick={(e) => {
                                            setSelectedItem(item);
                                            handleClick(e);
                                        }}
                                    >
                                        <MoreHorizIcon />
                                    </IconButton>

                                    {/* MUI Menu */}
                                    <Menu
                                        anchorEl={anchorEl}
                                        open={open && selectedItem?._id === item._id}
                                        onClose={handleClose}
                                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                                        PaperProps={{
                                            elevation: 0,
                                            sx: {
                                                borderRadius: '10px',
                                                boxShadow: 'none',
                                                border: '1px solid #E0E0E0',
                                            }
                                        }}
                                    >
                                        <MenuItem onClick={() => navigate(`/admin/story-perpose/${item?._id}`)} sx={{ color: '#5B93FF' }}>
                                            <EditIcon fontSize="small" sx={{ mr: 1 }} /> Edit
                                        </MenuItem>
                                        <MenuItem onClick={() => handleOnDelete(item)} sx={{ color: '#E71D36' }}>
                                            <DeleteIcon fontSize="small" sx={{ mr: 1, color: "error.main" }} /> Delete
                                        </MenuItem>
                                    </Menu>
                                </Box>
                                <Box
                                    sx={{
                                        border: '1px solid #01A0E2',
                                        height: '85px',
                                        width: '85px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: '50%',
                                        zIndex: 2,
                                        transition: 'background-color 0.5s ease',
                                    }}
                                >
                                    {/* Use the SVG as an image */}
                                    <img
                                        src={item?.image?.url}
                                        alt={item.title}
                                        className="hovereffect"
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                            transition: 'filter 0.5s ease',
                                        }}
                                    />
                                </Box>

                                <CardContent>
                                    <Typography
                                        variant="h5"
                                        sx={{
                                            mb: 1,
                                            fontWeight: 600, textAlign: 'center'
                                        }}
                                    >
                                        {item.title}
                                    </Typography>
                                    <Typography variant='body1' sx={{ fontSize: '16px', textAlign: 'center' }}>{item.content}</Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
            {/* Delete Modal */}
            <DeleteModal
                open={deleteOpen}
                handleDeleteClose={() => setDeleteOpen(false)}
                message="Are you sure you want to delete this story and perpose?"
                handleOnClick={handleDeleteConfirm}
            />
        </>
    )
}

export default StoryPerpose